module.exports = __webpack_public_path__ + "static/media/turtle.9c2bef97.svg";